import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:8000';

interface CompanyProfile {
  name: string;
  slogan: string;
  email: string;
  phone: string;
  website: string;
  address: string;
  facebook_url?: string; // URL Facebook
  twitter_url?: string; // URL Twitter
  linkedin_url?: string; // URL LinkedIn
  instagram_url?: string; // URL Instagram
  logo?: string;
  logo_url?: string; // URL complète du logo depuis le serveur
  iris_avatar?: string;
  iris_avatar_url?: string; // URL complète de l'avatar IRIS depuis le serveur
  tva_rate?: number; // Taux de TVA en pourcentage
  ninea?: string; // Numéro d'Identification National des Entreprises et Associations
  rccm?: string; // Registre du Commerce et du Crédit Mobilier
  legal_status?: string; // Statut juridique
}

class CompanyApiService {
  private getAuthHeaders() {
    const token = localStorage.getItem('access_token');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
  }

  // Récupérer le profil de l'entreprise (avec authentification)
  async getCompanyProfile(): Promise<CompanyProfile> {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/company/profile/`, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du profil entreprise:', error);
      throw error;
    }
  }

  // Récupérer le profil de l'entreprise (accès public, sans authentification)
  async getCompanyProfilePublic(): Promise<CompanyProfile> {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/company/profile/`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du profil entreprise (public):', error);
      throw error;
    }
  }

  // Mettre à jour le profil de l'entreprise
  async updateCompanyProfile(profile: CompanyProfile): Promise<CompanyProfile> {
    try {
      const response = await axios.put(`${API_BASE_URL}/api/company/profile/`, profile, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour du profil entreprise:', error);
      throw error;
    }
  }

  // Upload du logo
  async uploadLogo(file: File): Promise<string> {
    try {
      const formData = new FormData();
      formData.append('logo', file);

      const token = localStorage.getItem('access_token');
      const response = await axios.post(`${API_BASE_URL}/api/company/upload-logo/`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      return response.data.logoUrl;
    } catch (error) {
      console.error('Erreur lors de l\'upload du logo:', error);
      throw error;
    }
  }

  // Upload de l'avatar IRIS
  async uploadIrisAvatar(file: File): Promise<string> {
    try {
      const formData = new FormData();
      formData.append('iris_avatar', file);

      const token = localStorage.getItem('access_token');
      const response = await axios.post(`${API_BASE_URL}/api/company/upload-iris-avatar/`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      return response.data.irisAvatarUrl;
    } catch (error) {
      console.error('Erreur lors de l\'upload de l\'avatar IRIS:', error);
      throw error;
    }
  }
}

export const companyApiService = new CompanyApiService();
export type { CompanyProfile };
